// extracted by mini-css-extract-plugin
export default {"root":"ResendBeneficiaryDocumentsModal_root__MLNWf","title":"ResendBeneficiaryDocumentsModal_title__tdNED","info":"ResendBeneficiaryDocumentsModal_info__IaG+6"};